import apiClient from './axiosClient';

export const customerSearch = (unencodedQuery) => {
  const encodedQuery = encodeURIComponent(unencodedQuery)
  return apiClient.get(`/customers/?search=${encodedQuery}`);
}
export const getCustomers = () => apiClient.get(`/customers/`);
export const getCustomer = (id) => apiClient.get(`/customers/${id}/`);
export const createCustomer = (data) => apiClient.post(`/customers/`, data);
export const updateCustomer = (id, data) => apiClient.put(`/customers/${id}/`, data);
export const patchCustomer = (id, data) => apiClient.patch(`/customers/${id}/`, data);
export const deleteCustomer = (id) => apiClient.delete(`/customers/${id}/`);